/* tslint:disable */
/* eslint-disable */

/**
 * Nom des méthodes
 */
export enum WebApiSignalRServerMethod {
  Identify = 'Identify'
}
